import { styled } from 'styled-components';
import pluralize from 'pluralize';
import { Tooltip } from '@hn-ui/tooltips';
import { Help } from '@hn-ui/icons';

const ActivitiesRow = styled.div`
  display: grid;
  grid-template-columns: 420px 80px 100px 90px 115px;
  column-gap: 3%;

  &:last-child {
    padding-bottom: 20px;
  }
`;

const ActivitiesTxt = styled.p`
  font-family: var(--main-font);
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin-bottom: 16px;
  position: relative;
  color: ${({ theme }) => theme.colors.black40};
`;

const DeletedCardText = styled(ActivitiesTxt)`
  margin-left: 30px;
`;

const ActivitiesTxtAlignRight = styled(ActivitiesTxt)`
  text-align: right;
`;

const HelpIcon = styled(Help)`
  vertical-align: middle;
  margin-top: -3px;
  margin-left: 4px;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const createDeletedCardText = (cardsCount, hasActiveCards) => {
  const deletedCardsText = hasActiveCards
    ? `and ${cardsCount} more ${pluralize(
        'task',
        cardsCount
      )} (no longer available)`
    : `${pluralize('task', cardsCount, true)} no longer available`;

  return deletedCardsText;
};

const createTooltipText = (cardsCount) => {
  const tooltipText = `${pluralize('This', cardsCount)} ${pluralize(
    'task',
    cardsCount
  )} ${pluralize('was', cardsCount)} deleted from the platform
  by our content team and no longer available`;

  return tooltipText;
};

const DeletedCards = ({
  data: {
    accuracy,
    cardsCount,
    exerciseFinished,
    exerciseFinishedSucc,
    timeSpent,
  },
  hasActiveCards,
}) => {
  const deletedCardsText = createDeletedCardText(cardsCount, hasActiveCards);
  const tooltipText = createTooltipText(cardsCount);

  return (
    <ActivitiesRow>
      <DeletedCardText>
        {deletedCardsText}
        <Tooltip content={tooltipText} maxWidth='none'>
          <HelpIcon color='black70' />
        </Tooltip>
      </DeletedCardText>
      <ActivitiesTxtAlignRight />
      <ActivitiesTxtAlignRight />
      <ActivitiesTxtAlignRight>{`${timeSpent} min`}</ActivitiesTxtAlignRight>
      <ActivitiesTxtAlignRight>{`${exerciseFinishedSucc}/${exerciseFinished} (${accuracy}%)`}</ActivitiesTxtAlignRight>
    </ActivitiesRow>
  );
};
export default DeletedCards;
